import { type FC } from "react";

import { MetricDiff } from "../../shared/components/MetricDiff";

interface DiffSignProps {
    diffValue: string;
}

export const DiffSection: FC<DiffSignProps> = ({ diffValue }) => {
    return <MetricDiff diffValue={diffValue} />;
};
